"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostDetailsLayout = exports.PostDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var main_aside_1 = require("../elements/main-aside");
var entity_value_1 = require("./entity-value");
var link_1 = require("../elements/link");
var entity_link_value_1 = require("./entity-link-value");
var entity_list_1 = require("./entity-list");
var entity_list_section_1 = require("./entity-list-section");
var grid_1 = require("../elements/grid");
var link_value_1 = require("./link-value");
var content_title_1 = require("../elements/content-title");
var slice_layout_1 = require("./slice-layout");
var lodash_1 = require("lodash");
var entity_details_taxonomy_list_1 = require("./entity-details-taxonomy-list");
exports.PostDetailsLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding: ", " ", ";\n    ", ";\n    font-size: ", ";\n  "], ["\n    padding: ", " ", ";\n    ", ";\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG_END(), theme_1.theme.FONT_SIZE(20))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    padding: ", ";\n    padding-bottom: 0;\n  "], ["\n    padding: ", ";\n    padding-bottom: 0;\n  "])), theme_1.theme.UNIT(4))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    padding: ", " ", " 0;\n    font-size: ", ";\n    font-weight: 500;\n    color: ", " !important;\n\n    span, p {\n      color: ", " !important;\n    } \n  "], ["\n    padding: ", " ", " 0;\n    font-size: ", ";\n    font-weight: 500;\n    color: ", " !important;\n\n    span, p {\n      color: ", " !important;\n    } \n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.FONT_SIZE(16), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('dark'))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", ";\n\n    p {\n      margin-top: 1em;\n    }\n  "], ["\n    padding: ", ";\n\n    p {\n      margin-top: 1em;\n    }\n  "])), theme_1.theme.UNIT(3))
});
var SliceStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    box-sizing: border-box;\n    border-radius: 2px;\n    margin: ", " 0;\n  "], ["\n    box-sizing: border-box;\n    border-radius: 2px;\n    margin: ", " 0;\n  "])), theme_1.theme.UNIT(5))
});
var OutroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var LinkedValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TaxonomiesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    padding-top: ", " !important;\n  "], ["\n    padding-top: ", " !important;\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Slice: (0, styled_components_1.default)(slice_layout_1.SliceLayout)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), SliceStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  // LinkedValue: styled(EntityValue)`${LinkedValueStyles}`,
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Taxonomies: (0, styled_components_1.default)(entity_details_taxonomy_list_1.EntityDetailsTaxonomyList)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), TaxonomiesStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Intro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Outro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  Content: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
var PostDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    banner = props.banner;
  var content = entity.content,
    pretitle = entity.pretitle,
    title = entity.title,
    _a = entity.authors,
    authors = _a === void 0 ? [] : _a,
    _b = entity.organisationAuthors,
    organisationAuthors = _b === void 0 ? [] : _b,
    subtitle = entity.subtitle,
    intro = entity.intro,
    outro = entity.outro,
    path = entity.path,
    _c = entity.imageAssets,
    imageAssets = _c === void 0 ? [] : _c,
    _d = entity.organisations,
    organisations = _d === void 0 ? [] : _d,
    _e = entity.feedEntries,
    feedEntries = _e === void 0 ? [] : _e,
    _f = entity.people,
    people = _f === void 0 ? [] : _f,
    _g = entity.sites,
    sites = _g === void 0 ? [] : _g;
  var hasPeople = !!people.length;
  var hasSites = !!sites.length;
  var allAuthors = __spreadArray(__spreadArray([], __read(authors), false), __read(organisationAuthors), false);
  var gridItems = (0, lodash_1.filter)(__spreadArray(__spreadArray(__spreadArray([], __read(people.map(function (person) {
    return react_1.default.createElement(My.LinkValue, {
      showMenu: true,
      entity: person
    });
  })), false), __read(organisations.map(function (organisation) {
    return react_1.default.createElement(My.LinkValue, {
      showMenu: true,
      entity: organisation
    });
  })), false), __read(feedEntries.map(function (feedEntry) {
    return react_1.default.createElement(My.LinkValue, {
      showMenu: true,
      entity: feedEntry
    });
  })), false));
  var hasAside = asideHeader || asideFooter || hasSites || hasPeople;
  var siteLinks = sites.map(function (site) {
    return {
      id: "site-".concat(site.id),
      url: "".concat(site.url).concat(path),
      name: 'View post on website',
      __typename: 'Link'
    };
  });
  return react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(My.MainAside, {
    asideRatio: 2 / 7,
    space: 0,
    main: react_1.default.createElement(My.Main, null, mainHeader, title && react_1.default.createElement(My.Title, null, title), !!gridItems.length && react_1.default.createElement(My.Grid, {
      spacing: 4,
      columns: 2,
      items: gridItems
    }), react_1.default.createElement(My.Taxonomies, {
      entity: entity
    }), intro && react_1.default.createElement(My.Intro, {
      entity: intro
    }), content && react_1.default.createElement(My.Content, {
      entity: content
    }), outro && react_1.default.createElement(My.Outro, {
      entity: outro
    }), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, react_1.default.createElement(My.ListSection, {
      title: "",
      items: allAuthors,
      label: "{{AUTHOR}}"
    }), react_1.default.createElement(My.ListSection, {
      maxItems: 3,
      items: sites,
      title: ""
    }), react_1.default.createElement(My.ListSection, {
      title: "",
      useLinks: false,
      maxItems: 4,
      items: siteLinks,
      rowComponent: link_value_1.LinkValue
    }), asideFooter)
  }));
};
exports.PostDetailsLayout = PostDetailsLayout;
exports.PostDetailsLayout.defaultProps = exports.PostDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38;